import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Truck, ShieldCheck } from "lucide-react";

export const Footer = () => {
  const { t } = useLanguage();

  const features = [
    { icon: Truck, label: t("free_shipping") },
    { icon: ShieldCheck, label: t("quality_guarantee") },
  ];

  return (
    <footer className="mt-24 border-t border-[#27272A] bg-[#0A0A0B]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <div className="grid sm:grid-cols-2 gap-6 mb-10">
          {features.map((f, i) => (
            <div key={i} className="flex items-center gap-4 p-5 border border-[#27272A] rounded-xl">
              <div className="w-10 h-10 rounded-lg bg-[#D4AF37]/10 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37]">
                <f.icon size={18} />
              </div>
              <span className="text-sm text-[#F3F4F6]/85">{f.label}</span>
            </div>
          ))}
        </div>

        <div className="divider-gold mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div>
            <div className="font-display text-2xl gold-gradient-text font-bold">M16 / ام16</div>
            <div className="text-xs text-[#9CA3AF] mt-1">{t("brandTagline")}</div>
          </div>
          <div className="text-xs text-[#9CA3AF]">
            © {new Date().getFullYear()} M16 Store · UAE
          </div>
        </div>
      </div>
    </footer>
  );
};
